/** author：胡枭 */

<template>
  <div class="nav-bar flex-align__between" :class="`${currentPlatformAlias}`">
    <div class="nav-bar__left flex-align">
      <!--平台名称-->
      <div v-if="workbenchName" class="platform-title m-r-24">{{ workbenchName }}</div>
      <div v-else-if="supervise" class="platform-title m-r-24">
        {{ platformTitleDict.GZ.label }}
      </div>
      <template v-else>
        <i class="iconfont icon-logo m-r-10 font-36"></i>
        <div class="platform-title m-r-24">{{ platformTitle }}</div>
      </template>

      <!-- 官网首页按钮 -->
      <div class="portal-button flex row-center m-r-12 clickable" @click="toPortal">
        <i class="el-icon-s-home m-r-6"></i>
        <span>官网首页</span>
      </div>

      <!--工作台选择-->
      <el-dropdown
        v-if="currentWorkbench"
        class="dropdown-box"
        :disabled="!platformSelectionList.length"
      >
        <span class="el-dropdown-link dropdown-text">
          {{ currentWorkbenchName }}工作台
          <i
            v-if="platformSelectionList.length"
            class="iconfont icon--_qiehuan"
          ></i>
        </span>
        <el-dropdown-menu v-if="platformSelectionList.length" slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in platformSelectionList"
            :key="index"
          >
            <div
              style="height: 40px; padding: 5px 10px;"
              @click="switchPlatform(item)"
            >
              {{ item.label }}工作台
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!--    导航栏右侧内容-->
    <div class="nav-bar__right flex-align">
      <!--      工作台路由-->
      <div class="platform-btn-wrapper flex-align">
        <!--最多展示5个路由---->
        <div
          class="platform-btn"
          :class="{ active: currentFirstLevelRouteId === 'local-0' }"
          @click="handleCommand({ name: 'Homepage' })"
        >
          首页
        </div>
        <div
          v-for="menu in showFirstLevelRouteList"
          :key="menu.menuId"
          class="platform-btn"
          :class="{ active: currentFirstLevelRouteId === menu.id }"
          @click="handleCommand(menu)"
        >
          {{ menu.meta.title }}
        </div>

        <!--超过5个隐藏展示---->
        <el-dropdown
          v-if="collapseFirstLevelRouteList.length > 0"
          trigger="hover"
          size="medium"
        >
          <span class="more-btn">
            <i class="el-icon-more el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="menu in collapseFirstLevelRouteList"
              :key="menu.menuId"
              @click.native="handleCommand(menu)"
            >
              {{ menu.meta.title }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <!-- 消息通知 -->
      <div class="message-notify" @click="jumpNoticePage">
        <el-badge class="badge-item" :is-dot="Number(notifyNumber) > 0">
          <i class="iconfont icon-message notice-icon"></i>
        </el-badge>
      </div>

      <!-- 用户信息 -->
      <div>
        <el-dropdown trigger="click" :hide-on-click="false">
          <div class="user-info flex-align" :title="employeeName">
            <preview-image
              size="1.875rem"
              :src="require('@/assets/images/default-avatar.png')"
              :file-id="face"
              :around="true"
            />
            <span class="user-info__name text-ellipsis">
              {{ employeeName }}
            </span>
          </div>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-dropdown
                ref="companyDropdown"
                trigger="click"
                placement="right-start"
              >
                <div class="dropdown-item flex-align">
                  <i v-if="companyLoading" class="el-icon-loading"></i>
                  <i v-else class="el-icon-suitcase"></i>
                  <span>切换企业</span>
                </div>
                <el-dropdown-menu slot="dropdown" v-loading="companyLoading">
                  <el-dropdown-item
                    v-for="item in joinCompanyList"
                    :key="item.companyId"
                    :disabled="
                      item.companyStatus === companyStatusDict.FORBIDDEN.value
                    "
                  >
                    <div
                      class="dropdown-item flex-align"
                      @click="loginCompany(item)"
                    >
                      <i class="el-icon-office-building"></i>
                      <span>{{ item.companyName }}</span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div
                      class="dropdown-item flex-align"
                      @click="createNewCompany"
                    >
                      <i class="el-icon-circle-plus-outline"></i>
                      <span>新增企业</span>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-dropdown-item>
            <el-dropdown-item>
              <div class="dropdown-item flex-align" @click="showPersonSetting">
                <i class="el-icon-setting"></i>
                <span>个人中心</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item v-if="isPurchaser || isAgency">
              <div
                class="dropdown-item flex-align"
                @click="jumpPage('ToDoListAudit')"
              >
                <i class="el-icon-tickets"></i>
                <span>待办事项</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item v-if="isJxicPurchaser">
              <div
                class="dropdown-item flex-align"
                @click="jumpPage('JxicDocument')"
              >
                <i class="el-icon-tickets"></i>
                <span>文档资料</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div class="dropdown-item flex-align" @click="jumpToExpert">
                <i class="el-icon-s-operation"></i>
                <span>切换到专家工作台</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div class="dropdown-item flex-align" @click="handleLogout">
                <i class="el-icon-warning-outline"></i>
                <span>注销登录</span>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
// 组件
import PreviewImage from '@/components/common/Upload/PreviewImage'

// 工具函数
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import WujieVue from 'wujie-vue2'

// 数据字典
import { workbenchServiceDict, platformTitleDict } from '@/dictionary/system'
import { companyStatusDict } from '@/dictionary/company'
import { employeeStatusDict } from '@/dictionary/user'

// 后端api
import { enterCompanyApi, getJoinCompanyApi } from '@/api/user'

export default {
  name: 'NavBar',

  components: { PreviewImage },

  // 引入用户基本信息弹窗的展示函数
  inject: ['showPersonSetting', 'showCompanyChange'],

  data() {
    return {
      platformTitleDict,

      showMaxNum: 20, // 显示的工作台最大数量

      // 个人设置弹出框的展示
      settingDialog: false,
      noticeInstance: null,

      // 已加入企业
      joinCompanyList: [],
      companyLoading: false,

      // 数据字典
      companyStatusDict
    }
  },

  computed: {
    ...mapState('user', ['face', 'employeeName', 'roles']),
    ...mapState('system', ['notifyNumber']),
    ...mapState('company', [
      'supervise',
      'companyId',
      'companyType',
      'isSupplier',
      'isPurchaser',
      'isAgency',
      'workbenchName'
    ]),
    ...mapGetters('company', ['loginAddress', 'platformTitle', 'platformConfig']),
    ...mapState('router', [
      'currentWorkbench',
      'currentFirstLevelRouteId',
      'systemWorkbenchList'
    ]),
    ...mapGetters('router', ['workbenchMenuList']),

    // 当前工作台对应的工作台名称
    currentWorkbenchName() {
      return workbenchServiceDict.translate(this.currentWorkbench)?.label || ''
    },

    // 当前平台的alias
    currentPlatformAlias() {
      return platformTitleDict.array.filter(
        platform => platform.label === this.platformTitle
      )[0]?.alias
    },

    // 展示的一级路由
    showFirstLevelRouteList() {
      if (this.workbenchMenuList) {
        if (this.workbenchMenuList.length < this.showMaxNum) {
          return this.workbenchMenuList
        } else {
          return this.workbenchMenuList.slice(0, this.showMaxNum)
        }
      } else {
        return []
      }
    },

    // 折叠的一级路由
    collapseFirstLevelRouteList() {
      if (this.workbenchMenuList) {
        if (this.workbenchMenuList.length < this.showMaxNum) {
          return []
        } else {
          return this.workbenchMenuList.slice(
            this.showMaxNum,
            this.workbenchMenuList.length
          )
        }
      } else {
        return []
      }
    },

    // 下拉的工作台选择，根据公司开通的身份生成
    platformSelectionList() {
      return workbenchServiceDict.array.filter(platform => {
        return (
          this.systemWorkbenchList.includes(platform.value) &&
          platform.value !== this.currentWorkbench
        )
      })
    },

    // 是否是省投及其下属企业，且是在采购工作台
    isJxicPurchaser() {
      const isJxic = this.platformTitle === platformTitleDict.JXIC.value
      const isPurchaser =
        this.currentWorkbench === workbenchServiceDict.PURCHASER.value
      return isJxic && isPurchaser
    }
  },

  created() {
    this.getJoinCompany()
  },

  mounted() {
    this.setMaxShowNum()
    window.onresize = () => {
      this.setMaxShowNum()
    }
  },

  beforeDestroy() {
    window.onresize = null
  },

  methods: {
    ...mapMutations('system', {
      setUnreadNumber: 'SET_UNREAD_NUMBER'
    }),
    ...mapActions('user', ['logout', 'resetUser']),
    ...mapMutations('router', {
      clearCacheView: 'CLEAR_CACHE_VIEW',
      setFirstLevelRoute: 'SET_FIRST_LEVEL_ROUTE'
    }),
    ...mapActions('router', ['setCurrentWorkbench']),

    setMaxShowNum() {
      const width = window.innerWidth
      if (width < 750) {
        this.showMaxNum = 1
      } else {
        this.showMaxNum = (width - 750) / 100
      }
    },

    // 切换工作台
    switchPlatform(item) {
      this.setCurrentWorkbench(item.value).then(() => {
        const routerName = this.$route.name
        if (routerName != 'Homepage') {
          this.$router.replace({ name: 'Homepage' })
        }
      })
    },

    // 点击一级路由的处理函数
    handleCommand(route) {
      if (route.id === this.currentFirstLevelRouteId) return

      if (route?.meta?.isExternal) {
        window.open(route.path, '_blank')
        return
      }

      this.setFirstLevelRoute(route.id)
      const loop = list => {
        for (const route of list) {
          if (!route.hidden && !route.children) {
            return route
          }

          if (route?.children?.length) {
            return loop(route.children)
          }
        }
        return false
      }

      const routeTemp = loop(route.children || [route])
      if (routeTemp) {
        this.clearCacheView()
        // 微服务菜单
        if (routeTemp.meta?.isMicro) {
          this.$router.push({ name: routeTemp.name })
          WujieVue.bus.$emit('menu', routeTemp.name)
        } else {
          this.$router.push({ name: routeTemp.name })
        }
      }
    },

    jumpPage(name) {
      this.$router.push({ name })
    },

    // 退出登录
    handleLogout() {
      // 防止当前页面有beforeunload的阻拦
      window.onbeforeunload = null

      this.logout()
        .then(res => {
          window.location.href = this.loginAddress
        })
        .catch(err => {
          this.resetUser().then(res => {
            window.location.href = this.loginAddress
          })
        })
    },

    jumpNoticePage() {
      this.$router.push({ name: 'Notice' })
    },

    // 获取已加入企业
    getJoinCompany() {
      this.companyLoading = true
      getJoinCompanyApi()
        .then(res => {
          this.joinCompanyList = (res.data || []).filter(
            value => value.employeeStatus === employeeStatusDict.NORMAL.value
          )
        })
        .catch(err => {
          this.$message.error(err.message || '获取已加入企业失败，请稍后重试')
        })
        .finally(() => (this.companyLoading = false))
    },

    // 登录选中的企业
    loginCompany(company) {
      if (company.companyStatus === companyStatusDict.FORBIDDEN.value) {
        this.$message.warning('当前企业已被禁用，请选择其它企业')
        return
      }

      // 防止当前页面有beforeunload的阻拦
      window.onbeforeunload = null

      const temp = {
        employeeId: company.employeeId,
        companyId: company.companyId
      }
      enterCompanyApi(temp)
        .then(res => {
          if (res.success) {
            // 登录成功后跳转
            this.$router.push({ name: 'BlankPage' })
            setTimeout(() => {
              window.location.reload()
            }, 500)
          }
        })
        .catch(err => {
          this.$message.error(err.message || '登录企业失败，请稍后重试')
        })
    },

    // 跳转回登录平台的新增企业页面
    createNewCompany() {
      window.location.href = `${
        this.loginAddress
      }/cert/new/select?returnUrl=${encodeURIComponent(window.location.href)}`
    },

    // 切换到专家工作台
    jumpToExpert() {
      window.location.href = `${
        process.env.VUE_APP_EXPERT_URL
      }?returnUrl=${encodeURIComponent(window.location.href)}`
    },

    /**
     * 前往门户官网首页
     */
    toPortal() {
      window.location.href = `${
        this.platformConfig.portalUrl
      }?returnUrl=${encodeURIComponent(window.location.href)}`
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-bar {
  height: $header-height;
  background: $primary-color;
  padding: 0 24px;
  box-sizing: border-box;
  box-shadow: 0 0 5px #ccc;
  color: $white-color;

  &.xin-steel {
    background: linear-gradient(to right, #013586, #f50407);
  }

  // 顶部当行栏左侧样式
  .nav-bar__left {
    font-size: 1.75rem;
    white-space: nowrap;
    .platform-title {
      @include text-bold;
      white-space: nowrap;
    }

    .dropdown-box {
      cursor: pointer;
      border: 1px solid #d9d9d9;
      opacity: 1;
      border-radius: 4px;
      box-sizing: border-box;
      padding: 5px 10px;
    }
    .dropdown-text {
      font-size: 16px;
      color: #fff;
    }
  }

  // 顶部导航栏右侧样式
  .nav-bar__right {
    font-size: 1.25rem;

    & > div {
      margin-left: 2.5rem;
    }

    // 工作台路由按钮样式
    .platform-btn-wrapper {
      .platform-btn {
        position: relative;
        margin: 0 8px;
        padding: 10px 8px;
        white-space: nowrap;
        cursor: pointer;
        opacity: 0.8;

        &.active {
          opacity: 1;

          &::after {
            content: '';
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
            width: pixel-to-rem($n: 40);
            height: 2px;
            background: $white-color;
          }
        }

        &:hover {
          opacity: 1;
        }
      }
    }

    .message-notify {
      cursor: pointer;

      .badge-item {
        font-size: 1.5rem;

        .notice-icon {
          font-size: 20px;
        }
      }
    }

    .user-info {
      cursor: pointer;
      min-width: 100px;
      .user-info__name {
        display: inline-block;
        max-width: 100px;
        margin-left: 0.9375rem;
        color: $white-color;
      }

      @media screen and (max-width: 1199px) {
        .user-info__name {
          max-width: 0;
        }
      }
    }
  }
}

.dropdown-item {
  height: 36px;
  line-height: 1;

  i {
    font-size: 1.375rem;
  }
}

.gzw-logo {
  @include text-bold;
}

.more-btn {
  cursor: pointer;
  color: $white-color;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
}

.portal-button {
  width: 106px;
  height: 32px;
  font-size: 16px;
  background: rgba(255, 255, 255, .25);
  border-radius: 4px;
}
</style>
